import { render, staticRenderFns } from "./SearchGroup.vue?vue&type=template&id=04d95aca&scoped=true"
import script from "./SearchGroup.vue?vue&type=script&lang=js"
export * from "./SearchGroup.vue?vue&type=script&lang=js"
import style0 from "./SearchGroup.vue?vue&type=style&index=0&id=04d95aca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d95aca",
  null
  
)

export default component.exports